import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { AttendeeStatus } from '../../../../../constans/attendee-enums';
import {
  NO_ATTENDESS_MESSAGE_MAP,
  NO_RESULTS,
  NO_RESULTS_FOUND
} from '../../../../../constans/attendees-constants';
import { useStore } from '../../../../../store/store-provider';

const noAttendessMessage = (attendeeStatus: AttendeeStatus[]): string => {
  const mapKey: string = attendeeStatus.join('&');
  return NO_ATTENDESS_MESSAGE_MAP[mapKey] || NO_RESULTS_FOUND;
};

const NoAttendeeRow: FC = () => {
  const { attendeesStore: { getAttendeesService }} = useStore();
  const { isSearch, activityFilters } = getAttendeesService();

  return (
    <div className='no-active-attendee'>
      {isSearch ? NO_RESULTS : noAttendessMessage(activityFilters)}
    </div>
  );
};

export default observer(NoAttendeeRow);